<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import home from "@/views/home/index.vue";
export default {
  name: "App",
  components: { home },
  mounted() {
    // window.onerror = function (message, source, lineno, colno, error) {
    //   console.log("window错误");
    //   return true;
    // };
  },
};
</script>

<style>
/* 定义全局的css变量 */
/* 全局改变字体颜色 */  
body {  
 
  color: white; /* 设置你想要的字体颜色 */  
}  
:root {
  /* 背景色 */
  /* 标题高亮颜色 */
  --theme_title_color: #02e0db;
  --theme_yellow_color: #f7d84f;
  --theme_white_color: #ffffff;
  color: white;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
/* 滚动轴隐藏 */
 ::-webkit-scrollbar {
  display: none;
}

/* 隐藏 IE、Edge 和 Firefox 的滚动条 */
* {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

* {
  margin: 0;
  padding: 0;
}
</style>
